export enum IconButtonType {
    BACK = "BACK",
    FORWARD = "FORWARD",
    LEFT = "LEFT",
    RIGHT = "RIGHT",
    CLOSE = "CLOSE",
    TOP = "TOP",
    REFRESH = "REFRESH",
    MENU = "MENU",
    SETTINGS = "SETTINGS",
    INCREMENT = "INCREMENT",
    DECREMENT = "DECREMENT",
    REMOVE = "REMOVE",
    SHOW = "SHOW",
    HIDE = "HIDE",
    SCAN = "SCAN",
    SEARCH = "SEARCH"
}
